import type { QueryParamsDto } from "@mimber/schema"

export const communicationTemplatesKeys = {
  findAll: (params?: QueryParamsDto) =>
    params
      ? (["communication-templates", "findAll", params] as const)
      : (["communication-templates", "findAll"] as const),
  findOne: (uuid: string) =>
    ["communication-templates", "findOne", uuid] as const,
} as const
